import { QueryKeyEnum } from 'core/global.enum';
import { fetchServers } from 'api/servers/servers';
import { useQuery } from 'hooks/useQuery/useQuery';

import { InneEventsFilters } from './InneEventsFilters';
import { InneEventsFiltersContainerProps } from './InneEventsFilters.types';

export const InneEventsFiltersContainer = ({
  setTableSearchQuery,
  tableSearchQuery,
  tkdSearchQuery,
  setTkdSearchQuery,
}: InneEventsFiltersContainerProps) => {
  const { data: servers } = useQuery([QueryKeyEnum.SERVERS], fetchServers);

  return (
    <InneEventsFilters
      tableSearchQuery={tableSearchQuery}
      setTableSearchQuery={setTableSearchQuery}
      servers={servers?.data || []}
      tkdSearchQuery={tkdSearchQuery}
      setTkdSearchQuery={setTkdSearchQuery}
    />
  );
};
